import React from 'react';
import { Button } from '@cmp-src/buttons';
import { useTranslation } from 'react-i18next';

const classes = {
  Wrapper: 'flex w-full justify-between align-center px-1',
  CancelButtonLabel: 'font-semibold text-neutral-700 text-xs uppercase',
  ConfirmButtonLabel: 'font-semibold text-primary-800 text-xs uppercase',
  Button: 'border-0'
};

export interface ModalButtonsProps {
  onApply?: () => Promise<void> | void;
  onCancel?: () => Promise<void> | void;
}

export const ModalButtons: React.FC<ModalButtonsProps> = ({
  onApply,
  onCancel
}) => {
  const { t } = useTranslation('common');

  return (
    <div className={classes.Wrapper}>
      {onCancel ? (
        <Button
          variant={'transparent'}
          layout={'squared'}
          className={classes.Button}
          onClick={onCancel}
        >
          <span className={classes.CancelButtonLabel}>
            {t('modalActions.clear')}
          </span>
        </Button>
      ) : (
        <div />
      )}
      {onApply ? (
        <Button
          variant={'transparent'}
          layout={'squared'}
          className={classes.Button}
          onClick={onApply}
        >
          <span className={classes.ConfirmButtonLabel}>
            {t('modalActions.apply')}
          </span>
        </Button>
      ) : (
        <div />
      )}
    </div>
  );
};
